// Modules
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

// Components
import PurchaseLineItemsTable from './purchase-line-items-table';
import AddExpenseBill from './add-expense-bill';


// Component
export default class PurchaseLineItems extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { purchaseOrder } = this.props;
    purchaseOrder.unbilledLineItems = _.filter(purchaseOrder.lineItems, (lineItem) => lineItem.unbilledQuantity > 0);

    if (!purchaseOrder.unbilledLineItems.length) {
      return null;
    }

    return (
      <div>
        <PurchaseLineItemsTable
          enterReceipt={() => this.setState({ enteringReceipt: true })}
          purchaseOrder={purchaseOrder}
          enteringReceipt={this.state.enteringReceipt}
        />
        { this.state.enteringReceipt &&
          <AddExpenseBill
            cancel={() => this.setState({ enteringReceipt: false }) }
            purchaseOrder={purchaseOrder}
          />
        }
      </div>
    );
  }
}

// Prop types
PurchaseLineItems.propTypes = {
  purchaseOrder: PropTypes.object.isRequired
};
